export const MAX_ENTRIES_FOR_TREATMENT_TABLES = 5
